module.exports = __webpack_public_path__ + "img/jiaoyu_gansuzhongyiyao_suoluetu.ba0cdfaf.png";